import { useAppDispatch, useAppSelector } from '../../app/hooks';
import Search from '../search/Search';
import { SearchState } from '../search/SearchState';
import { searchState as sState } from '../search/SearchSlice';
import { useEffect } from 'react';
import { loginUsersListState, LoginUsersListState, searchLoginUsers } from './LoginUsersListSlice';
import { LoginUserWithAccount } from '../../services/UsersService';
import { Link } from 'react-router-dom';

const LoginUsersList = () => {
  const searchState: SearchState = useAppSelector(sState);
  const state: LoginUsersListState = useAppSelector(loginUsersListState);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (searchState.submitted) dispatch(searchLoginUsers({ email: searchState.submitted }));
  }, [searchState.submitted, dispatch]);

  return (
    <>
      <Search disabled={false} />
      <div className={`card`}>
        <div className="card-body">
          <div className="list-group list-group-flush my-n3">
            {state.loginUsers.map((user: LoginUserWithAccount) => (
              <div className="list-group-item">
                <div className="row align-items-center">
                  <div className="col-auto">
                    <img
                      src={user.circleSrc}
                      width="24px"
                      height="24px"
                      alt="user color circle"
                      className="rounded-circle"
                    ></img>
                  </div>
                  <div className="col ms-n2">
                    <h4 className="mb-1">email: {user.email}</h4>
                    <h4 className="small mb-0">company: {user.companyName}</h4>
                    <h4 className="small mb-0">admin: {user.adminEmail}</h4>
                    <h4 className="small mb-0">login user id: {user.loginUserId}</h4>
                    <h4 className="small mb-0">user id: {user.userId}</h4>
                    <h4 className="small mb-0">role: {user.role}</h4>
                    {user.apiToken && <h4 className="small mb-0">token: {user.apiToken}</h4>}
                    <h4 className="small mb-0">num cached: {user.numCached}</h4>
                  </div>
                  <div className="col-auto">
                    <Link className={`btn btn-sm btn-white`} to={`/users/${user.userId.toString()}`}>
                      account details
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginUsersList;
